<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">

      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <p class="p-login">Email</p>
                  <b-form-input alternative class="mb-3" name="Email"
                  @input="showError = false; isPasswordValid = null;" :rules="{ required: true, email: true }"
                    :state="isPasswordValid" prepend-icon="ni ni-email-83" placeholder="Email"
                    v-model="form.username"></b-form-input>
                  <b-form-invalid-feedback>
                  </b-form-invalid-feedback>

                  <p class="p-login">Password</p>
                  <b-form-input alternative class="mb-3" name="Password" :rules="{ required: true, min: 5 }"
                    prepend-icon="ni ni-lock-circle-open" type="password" v-model="form.password"
                    :state="isPasswordValid" placeholder="Contraseña" @input="showError = false; isPasswordValid = null;"></b-form-input>
                  <b-form-invalid-feedback>
                    <h3 class="text-center mb-2">
                      <b-badge variant="danger">
                        Usuario/Contraseña incorrectos
                      </b-badge>
                    </h3>
                  </b-form-invalid-feedback>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Ingresar</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>

          </b-card>
          <!---
          <b-row class="mt-3">
            <b-col cols="6">
              <router-link to="/dashboard" class="text-light"><small>Olvidaste tu contraseña?</small></router-link>
            </b-col>

          </b-row>-->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import authService from '@/api/authService';
export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      showError: false,
      isPasswordValid: null,
    };
  },
  methods: {
    async onSubmit() {
      try {
        Swal.fire({
          html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Iniciando...</h3>
                        </div>
                    </div>`,
          showConfirmButton: false,
          allowOutsideClick: false
        });
        const response = await authService.login(this.form);
        if (!response) throw new Error('Credenciales inválidas.');
        this.$router.push({ name: 'dashboard' });
        Swal.close();
      } catch (error) {
        Swal.close();
        this.showError = true;
        this.isPasswordValid = false;
      }


    }
  }
};
</script>

<style>
.p-login {
    margin-bottom: 0;
}
</style>